import React, { Component } from 'react'
import DialogWrapper from '../../../components/DialogWrapper';
import { APIData } from '../../../constants/APIAdresses';
import GenericTable from '../../../components/GenericTable/GenericTable';
import { formatDateBerlin } from '../../../App';

const formatMoney = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`
const formatPercent = (n) => `${Number(n).toFixed(2).replace('.', ',')} %`
const GiftCardEventType = {
    ISSUE: "Ausgestellt",
    ACTIVATE: "Aktiviert",
    CLAIM: "Zugewiesen",
    REDEEM: "Eingelöst",
    REDEEM_PENDING: "Einlösung ausstehend",
    REDEEM_CANCELED: "Einlösung storniert",
    REDEEM_ONSITE: "Vor Ort eingelöst",
    REFRESH_CODE: "Code erneuert",
    REFUND: "Rückerstattet",
    ADJUST: "Angepasst",
    DISABLE: "Deaktiviert",
    ENABLE: "Aktiviert",
    DEACTIVATE: "Gesperrt",
    REACTIVATE: "Entsperrt"
};
const columns = [
    {
        label: 'ID',
        dataKey: 'id',
        width: 80,
    },
    {
        label: 'Gutschein-ID',
        dataKey: 'giftCardId',
        width: 120,
    },
    {
        label: 'Ereignistyp',
        dataKey: 'eventType',
        width: 160,
        format: (value) => value != null ? GiftCardEventType[value] : '-',
    },
    {
        label: 'Kartentyp',
        dataKey: 'isPlatform',
        width: 120,
        format: (value) => value ? 'Plattform' : 'Shop',
    },
    {
        label: 'Ohne Zahlung',
        dataKey: 'withoutPayment',
        width: 130,
        format: (value) => value ? 'Ja' : 'Nein',
    },
    {
        label: 'Bestell-ID',
        dataKey: 'orderId',
        width: 120,
    },
    {
        label: 'Genutzter Betrag',
        dataKey: 'amount',
        width: 150,
        format: (value) => value != null && value !== 0 ? formatMoney(value) : '-',
    },
    {
        label: 'Restguthaben danach',
        dataKey: 'balanceAfter',
        width: 170,
        format: (value) => value != null ? formatMoney(value) : '-',
    },
    {
        label: 'Datum',
        dataKey: 'createdAt',
        width: 160,
        format: (value) => value ? formatDateBerlin(value) : '-',
    },
];

export default class GiftCardLedgerDialog extends Component {
    state = {
        allShopInfoList: [],
        selectedShopIds: this.props.shopId ? [{ id: this.props.shopId }] : [],
        preSelectedEntities: this.props.shopId ? [{ id: this.props.shopId }] : [],
        // selectedPromoCode: this.props.preSelectedPromoCode ?? null,
        selectedPromoCode: null,
        entitySelectionDialogOpen: false,
        entitySelectionDialogMultipleSelection: true,
        entitySelectionDialogTitle: "",
        entitySelectionDialogApiEndpoint: "",
        entitySelectionDialogIcon: null,
        entitySelectionDialogChipRenderContent: null,
        onEntitySelectionFinished: null,
        entitySelectionDialogMethod: "GET",
        entitySelectionDialogAdditionalKeyFields: [],
        entitySelectionDialogBody: undefined,
        tableData: [],
    }
    async componentDidMount() {
        // const result = await getShopInfoByIdList(null, this.props.companyId);
        // this.setState({ allShopInfoList: result });
    }
    filterEntitySelectionResults(result) {
        const { editMode } = this.state;
        if (!editMode) {
            return result.map(item => {
                const { added, ...rest } = item;
                return rest;
            }).filter(item => item.deselected !== true); // also remove deselected ones in creation mode, since they are not relevant at all
        }
        return result;
    }
    render() {
        const { shopId, companyId, open, onClose, showAlert } = this.props;
        return (
            <DialogWrapper maxWidth='xl' title="Historie" open={open} onClose={() => onClose()} >
                <GenericTable
                    config={{ columns: [...columns] }}
                    apiEndPoint={`${APIData.USER}/giftcard/giftCardLedger?companyId=${companyId}`}
                    tableData={this.state.tableData}
                    defaultItemsPerPage={25}
                    setTableData={(data) => this.setState({ tableData: data })}
                    onClickRow={(index) => {
                        // this.setState({
                        //     // dialogOpen: true,
                        //     conflictData: this.props.tableData[index],
                        // });
                    }}
                    noAdd
                />

            </DialogWrapper>
        )
    }
}
